import React, { MutableRefObject } from 'react';

import { TAB_FILTER_HEIGHT } from './OrganizationTabsFilter';
import {
  SubNavigation,
  SubNavigationSectionProps,
} from './SubNavigation/SubNavigation';

interface IProps {
  subNavigationData: SubNavigationSectionProps[];
  selected: string;
  setTargetTheme: React.Dispatch<React.SetStateAction<string>>;
  themeNodeRef: MutableRefObject<{
    [key: string]: HTMLElement;
  }>;
  fontColor: string;
}

export const OrganizationSubNavigation: React.FC<IProps> = ({
  subNavigationData,
  selected,
  setTargetTheme,
  themeNodeRef,
  fontColor,
}) => {
  return (
    <SubNavigation
      className='sticky	bottom-6 top-28 my-6 hidden max-h-screen overflow-y-auto webM:!flex'
      sections={subNavigationData}
      selected={selected}
      fontColor={fontColor}
      onClickHandler={(id) => {
        setTargetTheme(id);
        const element = themeNodeRef.current[id];
        const top = element.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: top - TAB_FILTER_HEIGHT,
          behavior: 'smooth',
        });
      }}
    />
  );
};
